import React, {memo, RefObject, ReactNode, useEffect, useState} from 'react'
import {Box, Button} from '@mui/material'
import {scrollButtonStyles} from '../../pages/home/stockBar/stockBar'
import {useResizeDetector} from 'react-resize-detector';
import ThinArrowRightIcon from "../../assets/icons/ThinArrowRightIcon";
import ThinArrowLeftIcon from "../../assets/icons/ThinArrowLeftIcon";

type HorizontalScrollButtonsProps = {
    children: ReactNode
    containerRef: RefObject<HTMLDivElement | undefined>;
};

const HorizontalScrollButtons: React.FC<HorizontalScrollButtonsProps> = ({children, containerRef}) => {
    const {width, ref} = useResizeDetector()
    const [canScrollLeft, setCanScrollLeft] = useState(false)
    const [canScrollRight, setCanScrollRight] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            if (containerRef.current) {
                const {scrollLeft, scrollWidth, clientWidth} = containerRef.current
                setCanScrollLeft(scrollLeft > 0)
                setCanScrollRight(Math.round(scrollLeft) + Math.round(clientWidth) < Math.round(scrollWidth))
            }
        }
        handleScroll()
        setTimeout(() => {
            handleScroll()
        }, 2000)
        const currentRef = containerRef.current
        if (currentRef) {
            currentRef.addEventListener('scroll', handleScroll)
            return () => {
                currentRef.removeEventListener('scroll', handleScroll)
            }
        }
    }, [width])

    const scrollLeft = () => {
        if (containerRef.current) {
            containerRef.current.scrollBy({left: -500, behavior: 'smooth'})
        }
    }

    const scrollRight = () => {
        if (containerRef.current) {
            containerRef.current.scrollBy({left: 500, behavior: 'smooth'})
        }
    }

    return (
        <Box sx={{
            position: 'relative',
            width: '100%',
            minWidth: 0,
            '&:hover .scroll-buttons': {
                opacity: 1
            }
        }} ref={ref}>
            {canScrollLeft && (
                <Button
                    className="scroll-buttons"
                    onClick={scrollLeft}
                    sx={{
                        ...scrollButtonStyles,
                        left: 0,
                    }}
                >
                    <ThinArrowLeftIcon fontSize="medium"/>
                </Button>
            )}
            {
                children
            }
            {canScrollRight && (
                <Button
                    className="scroll-buttons"
                    onClick={scrollRight}
                    sx={{
                        ...scrollButtonStyles,
                        right: 0,
                    }}
                >
                    <ThinArrowRightIcon fontSize={"medium"}/>
                </Button>
            )}
        </Box>
    )
}

export default memo(HorizontalScrollButtons);